module.exports = __webpack_public_path__ + "img/login_candidati.ff9d648c.jpg";